import { getAuthToken } from '../utils/authStorage';
import cookieConsentService from './cookieConsentService';

import API_BASE_URL from '../config/apiBaseUrl';
const VISITOR_KEY = 'np_visitor_id';

const generateVisitorId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `visitor_${Date.now()}_${Math.random().toString(16).slice(2)}`;
};

const getVisitorId = () => {
  try {
    const existing = localStorage.getItem(VISITOR_KEY);
    if (existing) return existing;
    const nextId = generateVisitorId();
    localStorage.setItem(VISITOR_KEY, nextId);
    return nextId;
  } catch {
    return generateVisitorId();
  }
};

const getLocale = () => {
  if (typeof navigator === 'undefined') return null;
  return navigator.language || (Array.isArray(navigator.languages) ? navigator.languages[0] : null);
};

const getCountryFromLocale = (locale) => {
  if (!locale) return null;
  const parts = String(locale).split(/[-_]/);
  if (parts.length < 2) return null;
  return parts[1].toUpperCase();
};

const getScreenSize = () => {
  if (typeof window === 'undefined' || !window.screen) {
    return { screenWidth: null, screenHeight: null };
  }
  const width = Number(window.screen.width);
  const height = Number(window.screen.height);
  return {
    screenWidth: Number.isFinite(width) && width > 0 ? Math.round(width) : null,
    screenHeight: Number.isFinite(height) && height > 0 ? Math.round(height) : null
  };
};

const analyticsService = {
  trackVisit: async (path) => {
    if (typeof path !== 'string' || path.trim() === '') return;
    const visitorId = getVisitorId();
    const token = getAuthToken();
    const analyticsConsent = cookieConsentService.canUseCategory('analytics');
    const locale = getLocale();
    const country = getCountryFromLocale(locale);
    const { screenWidth, screenHeight } = getScreenSize();

    try {
      await fetch(`${API_BASE_URL}/analytics/visit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Analytics-Consent': analyticsConsent ? '1' : '0',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify({
          path,
          visitorId,
          locale,
          country,
          analyticsConsent,
          screenWidth,
          screenHeight
        })
      });
    } catch {
      // Tracking best-effort only.
    }
  }
};

export default analyticsService;
